

























import Vue from 'vue';
import config from '../../config/index';
import { exportFiles, formatUrl, exportPostFiles } from '../../common/util';

interface WarnDialogData {
  isShow: boolean
}


export default Vue.extend({
  name: 'BatchImport',
  props: ['submitFailed', 'uploadFileList'],
  data(): WarnDialogData {
    return {
        isShow: false
    };
  },
  watch: {
      submitFailed(val) {
          this.isShow = val;
      }
  },
  computed: {
      
  },
  methods: {
      handleClose() {
          this.$emit('update:submitFailed', false);
      },
      exportFailList() {
          console.log(this.uploadFileList);
          let arr = this.uploadFileList.filter((item: any) => item.fileState !== 'Success' && item.fileState !== 'waiting');
          this.$http.post(`/api/HDCheck/ExportErrorList`, arr, {
              responseType: 'blob'
          }).then((res: any) => {
              let headerFileName = res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1];
              headerFileName = decodeURIComponent(headerFileName);
              // post导出方法
              exportPostFiles(res.data, headerFileName);
          });
      }
  },
  mounted() {
    
  }
});
